import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DiariasService from '../../../../services/diarias-auth';



const Diaria = () => {
    const [cargo, setCargo] = useState("");
    const [valor, setValor] = useState("");
    const [distancia, setDistancia] = useState("");
    const [indice, setIndice] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const dari = await DiariasService.cadastro({
                cargo: cargo,
                valor: valor,
                distancia: distancia,
                indice: indice
            })
            if (dari.data["_id"]) {
                alert("Diária cadastrada com sucesso!")
                setSucesso(true);
            }
            else {
                alert(dari.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setCargo("");
        setValor("");
        setDistancia("");
        setIndice("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                    <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Índice">
                                <FloatingLabel
                                    label="Índice"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Índice"
                                        name="indice"
                                        onChange={e => setIndice(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="I">I</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={10}>
                            <Form.Group className="mb-3" controlId="distancia">
                                <FloatingLabel
                                    label="Distância"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="distancia"
                                        value={distancia}
                                        onChange={e => setDistancia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>     
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>    
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cargo">
                                <FloatingLabel
                                    label="Cargo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cargo"
                                        value={cargo}
                                        onChange={e => setCargo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                                      

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/diarias'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Diária cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/diarias/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Tabela de Diárias
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/diarias'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Diaria;